// extracted by mini-css-extract-plugin
module.exports = {"animated":"e_xd","dots":"e_yd"};